import React from "react";

import Box from "./BillingBox";
import BillingIndianCustomer from "./BillingIndianCustomer";
class BillingList extends React.Component {
  render() {
    return (
      <>
        <section className="cloud-telephony integrationsec pb-5">
          <div className="container-fluid">
            <BillingIndianCustomer />
            <div className="row pt-4">
              <Box />
            </div>
          </div>
        </section>
      </>
    );
  }
}
export default BillingList;
